import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        selectedPath: '/',
        selectedIndex: 0,
        comparisons: [
            {
                id: 'busCards',
                image: '/items/bus.svg',
                text: '#value# stk. 180-dagers periodebillett',
                info: '4630 pr stk (voksen)' // 4630 - 4495 = 135
            },
            {
                id: 'electricBikes',
                image: '/items/electric-bike-brand.svg',
                text: '#value# stk. elsykler',
                info: '30 000,- pr sykkel'
            },
            {
                id: 'bikes',
                image: '/items/bike-brand.svg',
                text: '#value# stk. sykler',
                info: '8000,- pr sykkel'
            },
            {
                id: 'taxiRides',
                image: '/items/taxi-brand.svg',
                text: '#value# taxiturer',
                info: '305,- per tur'
            },
            {
                id: 'daysRentalCar',
                image: '/items/rental-car-brand.svg',
                text: '#value# dager leiebil',
                info: '2090,- per dag'
            },
            {
                id: 'joggingShoes',
                image: '/items/shoes-brand.svg',
                text: '#value# par joggesko',
                info: '1000,- per par'
            },
            {
                id: 'kickbikeRounds',
                image: '/items/kickbike-brand.svg',
                text: '#value# turer el-sparkesykkel',
                info: '40,- per tur a 10 min'
            },
            /* Hide for now cause they wanted 0 of these atm
            {
                id: 'numRentMonths',
                image: '/items/long-term-rental-car-brand.svg',
                text: '#value# måneder bilabonnement',
                info: '6200,- per måned'
            }
            */
        ],
        selections: [
            {
                label: 'Bil, gjennomsnitt',
                title: 'Kostnader ved å eie “gjennomsnittsbilen” WV Passat',
                type: 'vanlig bil',
                price: 461000,
                compareValues: {
                    busCards: 4,
                    electricBikes: 1,
                    bikes: 2,
                    taxiRides: 20,
                    daysRentalCar: 10,
                    joggingShoes: 2,
                    kickbikeRounds: 60,
                    numRentMonths: 0
                },
                rest: 11636, // 12176 - (4 * 135)
                costs: {
                    writeOffs: 38253,
                    interest: 13156,
                    insurance: 11297,
                    trafficInsuranceFee: 2820,
                    maintenance: 5094,
                    fuel: 10713,
                    oil: 1200,
                    tires: 6451,
                    serviceRepairs: 6428,
                    tolls: 12144
                },
                total: 107556,
                video: '/videos/bil_2.mp4',
                fallback: '/videos/bil_2.png',
                idleTime: 4
            },
            {
                label: 'Bil, liten',
                title: 'Kostnader ved å eie en liten bil',
                type: 'liten bil',
                price: 186700,
                compareValues: {
                    busCards: 2,
                    electricBikes: 1,
                    bikes: 1,
                    taxiRides: 10,
                    daysRentalCar: 5,
                    joggingShoes: 1,
                    kickbikeRounds: 20,
                    numRentMonths: 0
                },
                rest: 1109, // 1379 - (2 * 135)
                costs: {
                    writeOffs: 15790,
                    interest: 5845,
                    insurance: 6705,
                    trafficInsuranceFee: 2820,
                    maintenance: 4428,
                    fuel: 7672,
                    oil: 919,
                    tires: 2098,
                    serviceRepairs: 5247,
                    tolls: 12144
                },
                total: 63669,
                video: '/videos/bil_1.mp4',
                fallback: '/videos/bil_1.png',
                idleTime: 4
            },
            {
                label: 'Bil, stor/SUV',
                title: 'Kostnader ved å eie en SUV/stor bil',
                type: 'stor bil/SUV',
                price: 750000,
                compareValues: {
                    busCards: 4,
                    electricBikes: 2,
                    bikes: 2,
                    taxiRides: 30,
                    daysRentalCar: 10,
                    joggingShoes: 4,
                    kickbikeRounds: 100,
                    numRentMonths: 0
                },
                rest: 15219, // 15759 - (4 * 135)
                costs: {
                    writeOffs: 62558,
                    interest: 21398,
                    insurance: 16628,
                    trafficInsuranceFee: 2820,
                    maintenance: 5475,
                    fuel: 12233,
                    oil: 1200,
                    tires: 6698,
                    serviceRepairs: 6638,
                    tolls: 12144
                },
                total: 147789,
                video: '/videos/bil_3.mp4',
                fallback: '/videos/bil_3.png',
                idleTime: 4
            },
            {
                label: 'Elbil, gjennomsnitt',
                type: 'vanlig elbil',
                title: 'Kostnader ved å eie en elbil',
                price: 292400,
                compareValues: {
                    busCards: 2,
                    electricBikes: 1,
                    bikes: 1,
                    taxiRides: 10,
                    daysRentalCar: 5,
                    joggingShoes: 2,
                    kickbikeRounds: 20,
                    numRentMonths: 0
                },
                rest: 481, // 751 - (2 * 135)
                costs: {
                    writeOffs: 23387,
                    interest: 8545,
                    insurance: 10170,
                    trafficInsuranceFee: 0,
                    maintenance: 4714,
                    fuel: 2522,
                    oil: 0,
                    tires: 2854,
                    serviceRepairs: 5776,
                    tolls: 6072
                },
                total: 64041,
                video: '/videos/bil_5.mp4',
                fallback: '/videos/bil_5.png',
                idleTime: 4
            },
            {
                label: 'Elbil, liten',
                title: 'Kostnader ved å eie en liten elbil',
                type: 'liten elbil',
                price: 186700,
                compareValues: {
                    busCards: 1,
                    electricBikes: 1,
                    bikes: 1,
                    taxiRides: 5,
                    daysRentalCar: 1,
                    joggingShoes: 1,
                    kickbikeRounds: 20,
                    numRentMonths: 0
                },
                rest: 887, // 1022 - 135
                costs: {
                    writeOffs: 14722,
                    interest: 5452,
                    insurance: 8658,
                    trafficInsuranceFee: 0,
                    maintenance: 4386,
                    fuel: 2424,
                    oil: 0,
                    tires: 2047,
                    serviceRepairs: 5170,
                    tolls: 6072
                },
                total: 48932,
                video: '/videos/bil_4.mp4',
                fallback: '/videos/bil_4.png',
                idleTime: 4
            },
            {
                label: 'Elbil, stor/SUV',
                title: 'Kostnader ved å eie en stor elbil/SUV',
                type: 'stor elbil/SUV',
                price: 755500,
                compareValues: {
                    busCards: 4,
                    electricBikes: 2,
                    bikes: 2,
                    taxiRides: 20,
                    daysRentalCar: 10,
                    joggingShoes: 4,
                    kickbikeRounds: 100,
                    numRentMonths: 0
                },
                rest: 5143, // 5683 - 4 * 135
                costs: {
                    writeOffs: 63024,
                    interest: 21555,
                    insurance: 21996,
                    trafficInsuranceFee: 0,
                    maintenance: 5481,
                    fuel: 3195,
                    oil: 0,
                    tires: 6700,
                    serviceRepairs: 6640,
                    tolls: 6072
                },
                total: 134663,
                video: '/videos/bil_6.mp4',
                fallback: '/videos/bil_6.png',
                idleTime: 4
            }
        ],
        labels: {
            writeOffs: 'Avskrivninger',
            interest: 'Renter av bundet kapital',
            insurance: 'Forsikring',
            trafficInsuranceFee: 'Trafikkforsikringsavgift',
            maintenance: 'Vedlikehold',
            fuel: 'Drivstoff',
            oil: 'Olje',
            tires: 'Dekk',
            serviceRepairs: 'Service og reparasjoner',
            tolls: 'Bompenger'
        }
    },
    actions: {

    },
    mutations: {
        setSelectedPath (path) {
            state.selectedPath = path;
        },
        setSelectedIndex (state, index) {
            state.selectedIndex = index;
        }
    },
    getters: {
        activeSelection (state) {
            return state.selections[state.selectedIndex];
        },
        activeComparisons (state) {
            return state.comparisons.map(c => Object.assign({}, c, {value: state.selections[state.selectedIndex].compareValues[c.id]}));
        },
        activeDetails (state) {
            return Object.keys(state.labels)
                .map(k => ({label: state.labels[k], value: state.selections[state.selectedIndex].costs[k]}));
        }
    }
});
